import { COFAndIndividualQuestionnarieFormValues } from '../../../customers/types';

const getCofandIndividualQuestionnarieBody = ({
  questionnarieValues,
}: {
  questionnarieValues: COFAndIndividualQuestionnarieFormValues;
}) => {
  const questionnarieBody: COFAndIndividualQuestionnarieFormValues = {};

  if (questionnarieValues?.otherNationalitiesIds?.length) {
    questionnarieBody.otherNationalitiesIds =
      questionnarieValues?.otherNationalitiesIds;
  }

  if (questionnarieValues?.maritalStatus) {
    questionnarieBody.maritalStatus = questionnarieValues?.maritalStatus;
  }

  if (questionnarieValues?.spouseFullName) {
    questionnarieBody.spouseFullName = questionnarieValues?.spouseFullName;
  }

  if (questionnarieValues?.natureOfBusinessActivity) {
    questionnarieBody.natureOfBusinessActivity =
      questionnarieValues?.natureOfBusinessActivity;
  }

  if (questionnarieValues?.nameOfCompany) {
    questionnarieBody.nameOfCompany = questionnarieValues?.nameOfCompany;
  }

  if (questionnarieValues?.ownership?.toString()) {
    questionnarieBody.ownership = Number(questionnarieValues?.ownership);
  }

  if (questionnarieValues.belongsToGroup) {
    questionnarieBody.belongsToGroup = Boolean(
      questionnarieValues.belongsToGroup === 'yes',
    );
  }

  if (questionnarieValues?.parentCompanyName) {
    questionnarieBody.parentCompanyName =
      questionnarieValues?.parentCompanyName;
  }

  if (questionnarieValues?.parentCompanyCountryId) {
    questionnarieBody.parentCompanyCountryId =
      questionnarieValues?.parentCompanyCountryId;
  }

  if (questionnarieValues?.subsidiariesInfo) {
    questionnarieBody.subsidiariesInfo = questionnarieValues?.subsidiariesInfo;
  }

  if (questionnarieValues?.mainActivities) {
    questionnarieBody.mainActivities = questionnarieValues?.mainActivities;
  }

  if (questionnarieValues?.groupWealthSourceIds?.length) {
    questionnarieBody.groupWealthSourceIds =
      questionnarieValues?.groupWealthSourceIds;
  }

  if (questionnarieValues?.groupWealthSourceOther) {
    questionnarieBody.groupWealthSourceOther =
      questionnarieValues?.groupWealthSourceOther;
  }

  if (questionnarieValues?.estimatedTotalWealthEuro?.toString()) {
    questionnarieBody.estimatedTotalWealthEuro = Number(
      questionnarieValues?.estimatedTotalWealthEuro,
    );
  }

  if (questionnarieValues.requiresSourcesOfIncomes) {
    questionnarieBody.requiresSourcesOfIncomes = Boolean(
      questionnarieValues.requiresSourcesOfIncomes === 'yes',
    );
  }

  if (questionnarieValues?.sourcesOfIncomes?.length) {
    questionnarieBody.sourcesOfIncomes = questionnarieValues?.sourcesOfIncomes
      ?.filter((item) => item.sourceId)
      ?.map((item) => ({
        sourceId: item.sourceId,
        value: Number(item.value),
      }));
  }

  if (questionnarieValues?.sourcesOfIncomesOther) {
    questionnarieBody.sourcesOfIncomesOther =
      questionnarieValues?.sourcesOfIncomesOther;
  }

  if (questionnarieValues?.sourcesOfIncomesBorrowedOther) {
    questionnarieBody.sourcesOfIncomesBorrowedOther =
      questionnarieValues?.sourcesOfIncomesBorrowedOther;
  }

  if (questionnarieValues.requiresSourceAndSizeOfWealth) {
    questionnarieBody.requiresSourceAndSizeOfWealth = Boolean(
      questionnarieValues.requiresSourceAndSizeOfWealth === 'yes',
    );
  }

  if (questionnarieValues?.sourcesAndSizesOfWealth?.length) {
    questionnarieBody.sourcesAndSizesOfWealth =
      questionnarieValues?.sourcesAndSizesOfWealth
        ?.filter((item) => item.sourceId)
        ?.map((item) => ({
          sourceId: item.sourceId,
          value: Number(item.value),
        }));
  }

  if (questionnarieValues?.sourcesAndSizesOfWealthOther) {
    questionnarieBody.sourcesAndSizesOfWealthOther =
      questionnarieValues?.sourcesAndSizesOfWealthOther;
  }

  if (questionnarieValues?.sourcesAndSizesOfWealthBorrowedOther) {
    questionnarieBody.sourcesAndSizesOfWealthBorrowedOther =
      questionnarieValues?.sourcesAndSizesOfWealthBorrowedOther;
  }

  if (questionnarieValues.requiresNetWorth) {
    questionnarieBody.requiresNetWorth = Boolean(
      questionnarieValues.requiresNetWorth === 'yes',
    );
  }

  if (questionnarieValues?.netWorthAmount?.toString()) {
    questionnarieBody.netWorthAmount = Number(
      questionnarieValues?.netWorthAmount,
    );
  } else {
    questionnarieBody.netWorthAmount = null;
  }

  if (questionnarieValues?.sourcesOfFundsIds?.length) {
    questionnarieBody.sourcesOfFundsIds =
      questionnarieValues?.sourcesOfFundsIds;
  }

  if (questionnarieValues?.sourcesOfFundsOther) {
    questionnarieBody.sourcesOfFundsOther =
      questionnarieValues?.sourcesOfFundsOther;
  }

  if (questionnarieValues?.sourcesOfFundsLoanCreditInstitution) {
    questionnarieBody.sourcesOfFundsLoanCreditInstitution =
      questionnarieValues?.sourcesOfFundsLoanCreditInstitution;
  }

  if (questionnarieValues?.sourcesOfFundsLoanBusinessPartner) {
    questionnarieBody.sourcesOfFundsLoanBusinessPartner =
      questionnarieValues?.sourcesOfFundsLoanBusinessPartner;
  }

  if (questionnarieValues.hasAccountsInOtherFinancialInstitutions) {
    questionnarieBody.hasAccountsInOtherFinancialInstitutions = Boolean(
      questionnarieValues.hasAccountsInOtherFinancialInstitutions === 'yes',
    );
  }

  if (questionnarieValues?.otherFinancialInstitutions) {
    questionnarieBody.otherFinancialInstitutions =
      questionnarieValues?.otherFinancialInstitutions;
  }

  if (questionnarieValues?.groupWealthSourceOther) {
    questionnarieBody.groupWealthSourceOther =
      questionnarieValues?.groupWealthSourceOther;
  }

  if (questionnarieValues?.secondPassportExpiryDate) {
    questionnarieBody.secondPassportExpiryDate =
      questionnarieValues?.secondPassportExpiryDate;
  }

  if (questionnarieValues?.secondPassportIssueCountryId) {
    questionnarieBody.secondPassportIssueCountryId =
      questionnarieValues?.secondPassportIssueCountryId;
  }

  if (questionnarieValues?.secondPassportIssueDate) {
    questionnarieBody.secondPassportIssueDate =
      questionnarieValues?.secondPassportIssueDate;
  }

  if (questionnarieValues?.secondPassportNumber) {
    questionnarieBody.secondPassportNumber =
      questionnarieValues?.secondPassportNumber;
  }

  if (questionnarieValues?.isPepOrAssociate) {
    questionnarieBody.isPepOrAssociate = questionnarieValues?.isPepOrAssociate;
  }

  if (questionnarieValues.isPepOrAssociate) {
    questionnarieBody.isPepOrAssociate = Boolean(
      questionnarieValues.isPepOrAssociate === 'yes',
    );
  }

  if (questionnarieValues.hasAffiliatedCompanies) {
    questionnarieBody.hasAffiliatedCompanies = Boolean(
      questionnarieValues.hasAffiliatedCompanies === 'yes',
    );
  }

  if (questionnarieValues.nameOfPep) {
    questionnarieBody.nameOfPep = questionnarieValues.nameOfPep;
  }

  if (questionnarieValues.relToPep) {
    questionnarieBody.relToPep = questionnarieValues.relToPep;
  }

  if (questionnarieValues.orgEmployerAndPosition) {
    questionnarieBody.orgEmployerAndPosition =
      questionnarieValues.orgEmployerAndPosition;
  }

  if (questionnarieValues.positionHeldCountryId) {
    questionnarieBody.positionHeldCountryId =
      questionnarieValues.positionHeldCountryId;
  }

  if (questionnarieValues.politicalFunctionPeriodFrom) {
    questionnarieBody.politicalFunctionPeriodFrom =
      questionnarieValues.politicalFunctionPeriodFrom;
  }

  if (questionnarieValues.politicalFunctionPeriodTo) {
    questionnarieBody.politicalFunctionPeriodTo =
      questionnarieValues.politicalFunctionPeriodTo;
  }

  if (questionnarieValues.abilityMoveGovernmentFunds) {
    questionnarieBody.abilityMoveGovernmentFunds = Boolean(
      questionnarieValues.abilityMoveGovernmentFunds === 'yes',
    );
  }

  if (questionnarieValues.abilityMoveGovernmentFundsDetails) {
    questionnarieBody.abilityMoveGovernmentFundsDetails =
      questionnarieValues.abilityMoveGovernmentFundsDetails;
  }

  if (questionnarieValues.isUSCitizen) {
    questionnarieBody.isUSCitizen = Boolean(
      questionnarieValues.isUSCitizen === 'yes',
    );
  }

  if (questionnarieValues?.homePhoneNumber) {
    questionnarieBody.homePhoneNumber = questionnarieValues?.homePhoneNumber;
  }

  if (questionnarieValues?.emails?.length) {
    questionnarieBody.emails = questionnarieValues?.emails;
  }

  return questionnarieBody;
};

export default getCofandIndividualQuestionnarieBody;
